<template>
  <div class="add-role-container">
    <el-card class="filter-card">
      <div slot="header" class="clearfix">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-content">
          <el-breadcrumb-item to="/sys/role">角色管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="roleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="系统" prop="companyId">
          <el-select v-model="roleForm.companyId" placeholder="请选择系统" clearable filterable
                      style="width: 100%;" @change="getMenuTreeList">
            <el-option
                v-for="item in companyOptions"
                :key="item.companyId"
                :label="item.companyName"
                :value="item.companyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限字符" prop="roleKey">
          <el-input v-model="roleForm.roleKey" placeholder="请输入权限字符"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortNo">
          <el-input v-model="roleForm.sortNo" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="角色类型">
          <el-input v-model="roleForm.roleType" placeholder="请输入角色类型"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="roleDesc">
          <el-input v-model="roleForm.roleDesc" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="菜单权限" prop="menuIds" v-if="roleForm.companyId">
          <!-- <el-tree
            :data="menuList"
            show-checkbox
            ref="tree"
            check-strictly
            node-key="menuId"
            @check="getMenuIdList"
            :props="defaultProps">
          </el-tree> -->
           <el-tree
            ref="menuTree"
            :data="menuList"
            highlight-current
            accordion
            show-checkbox
            node-key="menuId"
            :default-expanded-keys="treeExpandMenuData"
            @check="getMenuIdList"
            :props="defaultProps"
          >
          </el-tree>
        </el-form-item>
        <div class="footer-btn">
          <el-button icon="el-icon-close" type="danger" size="small" @click="$router.back()">取 消</el-button>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="addDepartItem('ruleForm')">确 认</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getSystemData } from '@/api/systemMange';
import { getMenuList } from "@/api/menuMange";
import { addOrUpdateRoleInfo } from '@/api/roleMange'
export default {
  data () {
    return {
      title: '角色新增',
      companyOptions: [], // 所有系统列表
      menuList: [], // 菜单列表
      // 新增/编辑角色数据
      roleForm: {
        companyId: '',        // 系统ID
        roleName: '',         // 角色名称
        roleKey: '',          // 角色权限字符
        roleType: '',         // 角色类型
        sortNo: '',           // 排序
        roleDesc: '',         // 角色描述
        menuIds: [],          // 菜单ID
      },
      rules: {
        companyId: [
            {required: true, message: '请选择系统', trigger: ['change', 'blur']}
        ],
        roleName: [
            {required: true, message: '请输入角色名称', trigger: 'blur'}
        ],
        roleKey: [
            {required: true, message: '请输入角色权限字符', trigger: 'blur'}
        ],
        sortNo: [
            {required: true, message: '请输入排序', trigger: 'blur'}
        ],
        dataScope: [
            {required: true, message: '请选择权限范围', trigger: ['change', 'blur']}
        ],
        roleType: [
            {required: true, message: '请输入角色类型', trigger: 'blur'}
        ],
      },
      //默认展开的菜单节点
      treeExpandMenuData: [],
      treeList: [], // 部门树形列表
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      itemMenuIds: [],
      selectMenuList: []
    };
  },

  created() {
    if('roleName' in JSON.parse(this.$route.query.item)){
      this.title = '角色编辑'
      this.roleForm = JSON.parse(this.$route.query.item)
      this.roleForm.menuIds = JSON.parse(this.$route.query.item).selectAllMenuIds;
      this.getMenuTreeList()
    }
    this.getAllSystemInfo()
  },

  methods: {
    // 查询所有系统信息
    async getAllSystemInfo() {
      let searchSystemParams = {
        pageNo: 1,
        pageSize: 100,
        companyName: '',
        userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      }
      const res = await getSystemData(searchSystemParams);
      if (res.code == 200) {
        this.companyOptions = res.data.list
      } else {
        this.$message.error(res.msg)
      }
    },
    // 查询系统的所有菜单列表
    async getMenuTreeList() {
      let param = {
        companyId: this.roleForm.companyId,
        menuName: ''
      }
      const res = await getMenuList(param);
      if (res.code === '200') {
        this.menuList = res.data
        this.$refs.menuTree.setCheckedKeys(this.roleForm.menuIds);
      } else {
        this.$message.error(res.msg)
      }
    },
    // 新增角色选择菜单权限按钮
    getMenuIdList(data, checked, node) {
      this.roleForm.menuIds = checked.checkedKeys;
    },
    // 添加角色
    addDepartItem(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmChangeRoleInfo()
        } else {
          return false;
        }
      });
    },
    // 新增或修改角色信息
    async confirmChangeRoleInfo() {
      this.roleForm.menuIds = [...this.roleForm.menuIds, ...this.$refs.menuTree.getHalfCheckedKeys()]
      const res = await addOrUpdateRoleInfo(this.roleForm);
      if (res.code === '200') {
        this.title === '角色新增' ? this.$message.success('新增成功') : this.$message.success('修改成功')
        this.$router.back()
      } else {
        this.$message.error(res.msg)
      }
    },
  }
}

</script>
<style scoped>
::v-deep .el-form{
  width: 50%;
  margin: 0 auto;
}
</style>
<style lang='scss' scoped>
.footer-btn{
  margin: 80px 0 10px;
  text-align: center;
}
</style>
